// extracted by mini-css-extract-plugin
export default {"title":"F_-z","warning":"G_-z","sizeOptionsLegendText":"H_-z"};